import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import TrackCard from "../components/TrackCard";
import RadioPlayer from "../components/RadioPlayer";
import { ArrowRight, Sparkles, MessageSquare, Music } from "lucide-react";

export default function Home() {
  const [tracks, setTracks] = useState([]);

  useEffect(() => {
    api.get("/tracks").then(({ data }) => setTracks(data.slice(0, 4))).catch(() => {});
  }, []);

  return (
    <div className="relative">
      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://images.pexels.com/photos/9534914/pexels-photo-9534914.jpeg" alt="" className="w-full h-full object-cover opacity-40" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-[#09090B]" />
        </div>
        <div className="container-x relative z-10 py-24 md:py-40 grid md:grid-cols-12 gap-8">
          <div className="md:col-span-8">
            <div className="eyebrow mb-6" data-testid="hero-eyebrow">// Electronic · Funk · Analog Grooves</div>
            <h1 className="section-heading text-5xl sm:text-6xl md:text-7xl leading-[1.05] mb-6" data-testid="hero-heading">
              The sound of<br />
              <span className="led-2bfunk font-display" data-testid="hero-brand">2B&nbsp;FUNK</span>
              <br />in every track.
            </h1>
            <p className="text-lg text-white/70 max-w-xl mb-8 leading-relaxed">
              Buy single tracks, unlock monthly or annual subscriptions, chat with the 2BF music AI and join the community.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link to="/catalog" className="btn-primary flex items-center gap-2" data-testid="hero-cta-catalog">
                Explore Catalog <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/pricing" className="btn-outline" data-testid="hero-cta-pricing">View Plans</Link>
            </div>
          </div>
          <div className="md:col-span-4 hidden md:flex items-end justify-end">
            <RadioPlayer />
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="container-x py-24">
        <div className="grid md:grid-cols-3 gap-8">
          <FeatureCard icon={<Music className="w-6 h-6" />} title="Curated Catalog" desc="Original tracks by 2B FUNK, from deep funk to experimental electronic." />
          <FeatureCard icon={<Sparkles className="w-6 h-6" />} title="2BF AI" desc="The music AI that answers every sonic curiosity you have." />
          <FeatureCard icon={<MessageSquare className="w-6 h-6" />} title="Community" desc="Live chat with subscribers, share playlists and discover new sounds." />
        </div>
      </section>

      {/* FEATURED TRACKS */}
      <section className="container-x py-16">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="eyebrow mb-3">Featured</div>
            <h2 className="section-heading">Latest Releases</h2>
          </div>
          <Link to="/catalog" className="hidden sm:flex items-center gap-2 text-sm font-mono-plex uppercase tracking-widest text-white/60 hover:text-[#FF5E00]" data-testid="featured-see-all">
            See all <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {tracks.map((t) => <TrackCard key={t.id} track={t} />)}
        </div>
      </section>

      <div className="h-32" />
    </div>
  );
}

function FeatureCard({ icon, title, desc }) {
  return (
    <div className="border border-white/5 bg-[#121217] p-8 hover:border-[#FF5E00]/40 transition-all group">
      <div className="w-12 h-12 flex items-center justify-center border border-[#FF5E00]/40 text-[#FF5E00] mb-6 group-hover:bg-[#FF5E00] group-hover:text-black transition-colors">
        {icon}
      </div>
      <h3 className="font-display font-bold text-xl mb-2">{title}</h3>
      <p className="text-sm text-white/60 leading-relaxed">{desc}</p>
    </div>
  );
}
